import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';

import styles from './banner.module.less';

const ROLE_PLAY_IMAGE_DIRECTORY = '/staticx/udemy/images/role-play';

const rolePlayImageUrl = (fileName: string): string => {
    const assetPrefix = process.env.ASSET_PREFIX ?? '';
    return `${assetPrefix.replace(/\/$/, '')}${ROLE_PLAY_IMAGE_DIRECTORY}/${fileName}`;
};

const IMAGE_SIZES = '(max-width: 467px) calc(100vw - 48px), 420px';

// Spread as lowercase because React 17 types lack `fetchPriority` and it warns on the camelCase prop.
const HIGH_PRIORITY_IMAGE_PROPS = {
    fetchpriority: 'high',
};

export const Banner: React.FC = () => {
    const {gettext} = useI18n();
    const desktopImageUrl = rolePlayImageUrl('roleplay-topics-image-420x300.webp');
    const retinaImageUrl = rolePlayImageUrl('roleplay-topics-image-840x600.webp');
    const imageSrcSet = `${desktopImageUrl} 420w, ${retinaImageUrl} 840w`;

    return (
        <div className={styles['container']}>
            <div className={classNames('ud-container', styles.banner)}>
                <div className={styles['banner-header']}>
                    <h1 className={'ud-heading-serif-xxl'}>
                        {gettext('Turn learning into real-world practice with Practice Role Play')}
                    </h1>
                    <p className={'ud-text'}>
                        {gettext(
                            'Knowing and doing are not the same. Practice Role Play is your chance to put new skills to the test before it counts. Step into realistic scenarios right after you learn, practice with an AI-powered avatar, get feedback, and go again until it clicks.',
                        )}
                    </p>
                </div>

                <div className={styles['banner-image-container']}>
                    <Image
                        alt=""
                        className={styles['banner-image']}
                        src={desktopImageUrl}
                        srcSet={imageSrcSet}
                        sizes={IMAGE_SIZES}
                        height={300}
                        width={420}
                        {...HIGH_PRIORITY_IMAGE_PROPS}
                    />
                </div>
            </div>
        </div>
    );
};
